import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/servicenow.vue
var o = {
	name: "DtIconServicenow",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--servicenow"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Servicenow",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M12.062 3C6.579 2.967 2.049 7.455 2 12.955a10.05 10.05 0 0 0 3.14 7.39c.707.674 1.809.74 2.581.14 1.135-.888 2.598-1.423 4.283-1.423 1.677 0 3.14.526 4.283 1.422.78.609 1.882.527 2.597-.147a10.044 10.044 0 0 0 3.124-7.292C22 7.513 17.553 3.033 12.062 3Zm-.058 15.06c-2.967 0-4.998-2.236-4.998-4.998s2.03-5.04 4.998-5.04c2.968 0 4.998 2.27 4.998 5.04 0 2.762-2.03 4.998-4.998 4.998Z",
		fill: "#83B6A2"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=servicenow.js.map